import { Component, EventEmitter, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { User } from '@greco/identity-users';
import { UserService } from '@greco/ngx-identity-auth';
import { BehaviorSubject, of } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';

@Component({
  selector: 'greco-email-verification-requirement',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss'],
})
export class EmailVerificationRequirementComponent {
  @Output() refreshed = new EventEmitter<void>();

  constructor(private userSvc: UserService, private snacks: MatSnackBar) {}

  refresh$ = new BehaviorSubject<void>(undefined);

  user$ = this.refresh$.pipe(
    switchMap(() =>
      this.userSvc.getUserId().pipe(
        switchMap(userId => (userId ? this.userSvc.getUser(userId) : of(null))),
        shareReplay(1)
      )
    )
  );

  async verifyEmailAddress(user: User) {
    // await this.userSvc.sendEmailVerification();
    this.snacks.open(`Email verification sent to ${user.contactEmail}`, 'Ok', {
      panelClass: 'mat-primary',
      duration: 2500,
    });
  }

  refresh() {
    // this.refresh$.next();
    // this.refreshed.emit();
    location.reload(); // FIXME(adaoust): Temp solution, cannot get latest user via refreshes;
  }
}
